<script lang="ts">
	import { storeInfoMenu } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { getContextScope } from '$lib/js/helpers/i18n'

	let options: Array<{ icon: string, link: string; text: string }> = [
		{ icon: 'questions', link: `centro-de-ayuda`, text: $t`Help center` },
		{ icon: 'info', link: `contact`, text: $t`Contact and tracking` },
		{ icon: 'hello', link: `blog`, text: $t`News and updates` },
		{ icon: 'leaf', link: `sostenibilidad`, text: $t`Sustainability` },
		{ icon: 'badge', link: `brands`, text: $t`Our brands` },
		{ icon: 'trophy', link: `opiniones`, text: $t`Reviews` },
		{ icon: 'us', link: `quienes-somos`, text: $t`About us` },
	]
	const scope = getContextScope()

	function closeMenu() {
		$storeInfoMenu = ''
	}
</script>


<button class="info-menu" on:mouseleave={() => closeMenu()}>
	<div class="info-menu__inner">
		{#each options as option}
			<a href="/{scope}/{option.link}" on:click={() => closeMenu()}>
				<span class="icon icon-{option.icon}"></span> {option.text}
			</a>
		{/each}
	</div>
</button>


<style lang="scss">
  .info-menu {
    position: absolute;
    z-index: 99;
    top: 46px;
    right: 0;
    width: 230px;
    text-align: left;
    padding-top: 8px;

    &::after {
      content: "";
      position: absolute;
      right: 59px;
      top: -2px;
      display: block;
      width: 30px;
      height: 30px;
      transform: rotate(45deg);
      background: white;
      border-radius: 5px;
    }

    &__inner {
      background: white;
      border-radius: 7px;
      padding: 12px 25px;
      box-shadow: 0px 4px 20px 10px rgba(0, 0, 0, 0.12);
      position: relative;
    }

    a {
      display: block;
      color: black;
      padding: 7px 0;

      &:hover {
        color: var(--main);
      }

      span {
        margin-right: 8px;
        font-size: 18px;
      }
    }
  }
</style>
